export const ADMIN_GROUP_REF = 'group:default/backstage_devops';
